import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CustomEditor = ({ containerClassName, ...props }) => {
  return (
    <div className={`${containerClassName || "h-[640px]"} [&_.quill]:flex [&_.quill]:flex-col [&_.ql-container]:!flex-1 [&_.ql-container]:!min-h-0`}>
      <ReactQuill theme="snow" {...props} style={{ height: "100%" }} />
    </div>
  );
};

export default CustomEditor;
